import { useMemo } from 'react';
import { useFinance } from '@/contexts/FinanceContext';
import type { DREPeriodFilter, DREMonthlyReport } from './types';
import { buildMonthlyDRE } from './dreMonthly';

export function useDRE(filter: DREPeriodFilter): DREMonthlyReport {
  const { transactions, categories } = useFinance();

  return useMemo(
    () => buildMonthlyDRE(transactions, categories, filter),
    [transactions, categories, filter],
  );
}
